// this will me moved to its own component
import React, { useState, useEffect } from 'react';

export const TalentMatchWidget = () => {
  const [widget, setWidget] = useState(null);

  const getWidget = async () => {
    const thinForm = false;
    const context = 'job-alert-modal-int-widget';

    const query = [
      'type=',
      `context=${context}`,
      `thinForm=${thinForm}`,
      'hideFromOptedInUsers=true',
      'hideWhenAllFieldsComplete=true',
      'title=Want to find the perfect job faster?',
      'introduction=Simply tell us a little more about your experience and what you’re looking for and we can contact you about jobs we think match your profile.',
    ].join('&');

    try {
      const response = await fetch(`/widget/int-talent-capture/lite?${query}`);

      const responseWidget = await response.text();
      setWidget(responseWidget);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Widget did not show');
    }
  };

  useEffect(() => {
    getWidget();
  }, []);

  const id = 'talent-widget-placeholder';
  return (
    <div
      id={id}
      className=""
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: widget }}
    />
  );
};
